module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "watchStuHead"
  }, [_c('div', {
    staticClass: "watContent"
  }, [_c('div', {
    staticClass: "watConTitle"
  }, [(_vm.useInfo.avatar && _vm.useInfo.avatar.length > 0) ? _c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.useInfo.avatar
    }
  }) : _c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": require("./../../assets/img/photo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "realName"
  }, [_c('p', {
    staticClass: "studenName"
  }, [_c('span', [_vm._v(_vm._s(_vm.useInfo.realName))])]), _vm._v(" "), _c('p', {
    staticClass: "studenNum"
  }, [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("学生号 : ")]), _c('span', [_vm._v(_vm._s(_vm.useInfo.userId))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "stuConCount"
  }, [_c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.userScore, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("分数")])]), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm.userRank))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("名次")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d609d08","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/watchStuHead/watchStuHead.vue
// module id = 1161
// module chunks = 1